<div class="modal fade" id="updatePaymentModal" tabindex="-1" role="dialog" aria-labelledby="updatePaymentLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        @if (iStudent && iPayment && !isRefund) {
          <h3 class="modal-title" id="updatePaymentTitle">
            MODIFIER LE PAIEMENT #{{iPayment.paymentId}} - {{iStudent.lastname}} {{iStudent.firstname}}
          </h3>
        }
        @if (iStudent && iPayment && isRefund) {
          <h3 class="modal-title" id="refundPaymentTitle">
            EFFECTUER UN REMBOURSEMENT - {{iStudent.lastname}} {{iStudent.firstname}}
          </h3>
        }
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      @if (popupError && popupError.length > 0) {
        <div id="updatePaymentError" class="alert alert-danger mt-4 ms-4 me-4" role="alert">
          {{popupError}}
        </div>
      }

      <form [formGroup]="paymentForm" #f="ngForm" name="updateEventForm" (ngSubmit)="f.form.valid && onUpdatePayment()" novalidate>
        <div>
          <div class="form-row ms-4 p-1 mt-4">
            <div class="input-group raw mb-3">
              <div class="col-4">
                <label for="payment-date" class="col-form-label">CHOISIR LA DATE</label>
                <input id="payment-date" type="date" class="form-control form-control-lg form-control-borderless"
                  name="date" formControlName="date" required aria-describedby="basic-addon2">
                @if (paymentSubmited && f.form.controls.date.status == 'INVALID') {
                  <p class="alert alert-danger p-0" role="alert">
                    Merci de définir la date !
                  </p>
                }
              </div>
              <div class="col-6">
                <label for="amount-u" class="col-form-label">MONTANT DU PAIEMENT</label>
                <input id="amount-u" type="number" class="form-control form-control-lg form-control-borderless"
                  name="amount" formControlName="amount" required aria-describedby="basic-addon2" min="1" value="{{iPayment?.amount}}">
                @if (paymentSubmited && f.form.controls.amount.status == 'INVALID') {
                  <p class="alert alert-danger p-0" role="alert">
                    Merci de définir un montant !
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="form-row ms-4 p-1 mt-1">
            <div class="input-group raw mb-3">
              <div class="col-4">
                <label for="editPayment-mode" class="col-form-label">MODE DE PAIEMENT</label>
                <select id="editPayment-mode" class="form-control form-control-lg form-control-borderless" formControlName="paymentMethod" [value]="$safeNavigationMigration(iPayment?.paymentMethod)"> <!--(change)="selectMonitor($event)" -->
                  <option [ngValue]="null" disabled></option>
                  <option value="ESPECE">ESPECE</option>
                  <option value="CHEQUE">CHEQUE</option>
                  <option value="CB">CB</option>
                </select>
                @if (paymentSubmited && f.form.controls.paymentMethod.status == 'INVALID') {
                  <p class="alert alert-danger p-0" role="alert">
                    Merci de choisir une méthode de paiement !
                  </p>
                }
              </div>
              <div class="col-6">
                <label for="editPaymentDescription" class="col-form-label">DESCRIPTION</label>
                <textarea class="form-control" id="editPaymentDescription" name="description" formControlName="description" rows="3"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ANNULER</button>
          <button class="btn btn-primary" type="submit">VALIDER</button>
        </div>
      </form>
    </div>
  </div>
</div>
